// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".prom-header .card .card__image{background-color:#303538!important}.prom-header .card .card__bottom{min-height:unset}.prom-header .chips{margin-left:10px}@media only screen and (max-width:460px){.prom-header .chips{margin-left:-2px;margin-top:-5px}}.prom-header .chips .chip:not(:last-of-type){margin-right:10px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
